// Home.news

module.exports = {
  services: {
    title: {
      en: "Applications",
      fr: "Applications"
    }
  }
};
